module.exports = __webpack_public_path__ + "static/media/Lsign.cf8792e3.png";